import { GridItemNormalizer } from '../types';

export default class CostAccountObjectNormalizer implements GridItemNormalizer {
  support(value: any): boolean {
    return value?.__typename === 'object_CostAccountNEW' || value?.__typename === 'object_CostAccount';
  }

  normalize(value: any) {
    return value?.CostAccount;
  }

  normalizeAsSelectValue(value: any) {
    return this.normalize(value);
  }

  getRequiredFields() {
    return {
      id: '',
      CostAccount: '',
    };
  }
}
